(() => {
  'use strict';
  if (window.PBJourneyTracking) return;

  const JOURNEY_KEY = 'pb_keepsake_journey_v1';
  const JOURNEY_TTL = 30 * 60 * 1000;
  const GA_DESTINATION = 'G-BH383LQYPZ';

  const isInternalQA = () => {
    try {
      return Boolean(window.PBQA?.isInternal || sessionStorage.getItem('pb_qa_mode'));
    } catch (_) {
      return Boolean(window.PBQA?.isInternal);
    }
  };

  const clarityCall = (...args) => {
    let attempts = 0;
    const call = () => {
      if (typeof window.clarity === 'function') {
        try { window.clarity(...args); } catch (_) {}
        return;
      }
      if (attempts++ < 20) window.setTimeout(call, 250);
    };
    call();
  };

  const setClarityTag = (key, value) => {
    if (value === undefined || value === null || value === '') return;
    clarityCall('set', String(key), String(value));
  };

  const googleEvent = (name, payload) => {
    if (isInternalQA()) return;
    const eventPayload = { send_to: GA_DESTINATION, ...payload };
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, eventPayload);
        return;
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...eventPayload });
    } catch (_) {}
  };

  const track = (name, payload = {}) => {
    if (isInternalQA()) return;
    googleEvent(name, payload);
    clarityCall('event', name);
  };

  const normalizePath = href => {
    try { return new URL(href, window.location.origin).pathname; }
    catch (_) { return ''; }
  };

  const formatFromHref = href => {
    const path = normalizePath(href);
    if (path.includes('/products/personalized-book-style-keepsake-box')) return 'book_style';
    if (path.includes('/products/personalized-linen-keepsake-box')) return 'standard';
    return '';
  };

  const selectionPlacement = target => {
    if (target.closest('.pb-klp__hero-photo')) return 'hero_image';
    if (target.closest('.pb-klp__text-link')) return 'hero_text_link';
    if (target.closest('.pb-klp__product-media')) return 'product_media';
    if (target.closest('.pb-klp__product-body h3')) return 'product_title';
    if (target.closest('.pb-klp__product-card .button')) return 'product_button';
    if (target.closest('.pb-klp__product-card')) return 'product_card';
    if (target.closest('.pb-km__card-link')) return 'marketplace_design_card';
    return 'collection_link';
  };

  const storeJourney = payload => {
    try {
      sessionStorage.setItem(JOURNEY_KEY, JSON.stringify({ ...payload, ts: Date.now() }));
    } catch (_) {}
  };

  const readJourney = () => {
    try {
      const raw = sessionStorage.getItem(JOURNEY_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed?.ts || Date.now() - parsed.ts > JOURNEY_TTL) {
        sessionStorage.removeItem(JOURNEY_KEY);
        return null;
      }
      return parsed;
    } catch (_) {
      return null;
    }
  };

  const recordSelection = ({ format, placement, destinationPath, designHandle = '' }) => {
    if (!format || isInternalQA()) return;
    const payload = {
      box_format: format,
      selection_placement: placement || 'collection_link',
      destination_path: destinationPath || '',
      collection_handle: 'keepsake-boxes',
      design_handle: designHandle || ''
    };
    storeJourney({
      route: 'collection_first',
      format,
      placement: payload.selection_placement,
      destinationPath: payload.destination_path,
      designHandle: payload.design_handle
    });
    setClarityTag('keepsake_entry_route', 'collection_first');
    setClarityTag('keepsake_type_selected', format);
    setClarityTag('keepsake_select_placement', payload.selection_placement);
    if (payload.design_handle) setClarityTag('keepsake_design_handle', payload.design_handle);
    track('keepsake_type_select', payload);
  };

  const handleCollectionClick = event => {
    if (!event.isTrusted || isInternalQA()) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const classicRoot = target.closest('[data-pb-klp], [data-pb-klp-bottom]');
    const marketplaceRoot = target.closest('[data-pb-km]');
    if (!classicRoot && !marketplaceRoot) return;

    let link = target.closest('a[href]');
    if (!link && classicRoot) {
      const card = target.closest('.pb-klp__product-card');
      link = card?.querySelector('.pb-klp__product-body h3 a[href]') || null;
    }
    if (!link) return;

    const format = formatFromHref(link.href);
    if (!format) return;

    const designCard = target.closest('[data-pb-km-card]');
    recordSelection({
      format,
      placement: selectionPlacement(target),
      destinationPath: normalizePath(link.href),
      designHandle: designCard?.dataset.handle || ''
    });
  };

  const detectPdp = () => {
    const format = formatFromHref(window.location.href);
    if (!format || isInternalQA()) return;

    const marker = readJourney();
    let route = 'direct_pdp';
    if (marker?.route === 'collection_first' && marker.format === format) {
      route = 'collection_first';
    } else {
      try {
        const ref = document.referrer ? new URL(document.referrer) : null;
        if (ref?.origin === window.location.origin) route = 'internal_other';
      } catch (_) {}
    }

    document.documentElement.dataset.pbKeepsakeEntryRoute = route;
    document.documentElement.dataset.pbKeepsakeFormat = format;
    setClarityTag('keepsake_entry_route', route);
    setClarityTag('keepsake_box_format', format);
    if (marker?.placement) setClarityTag('keepsake_select_placement', marker.placement);
    if (marker?.designHandle) setClarityTag('keepsake_design_handle', marker.designHandle);

    track('keepsake_pdp_entry', {
      box_format: format,
      entry_route: route,
      collection_select_placement: marker?.placement || '',
      design_handle: marker?.designHandle || ''
    });
  };

  document.addEventListener('click', handleCollectionClick, true);

  const boot = () => {
    detectPdp();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  window.PBJourneyTracking = {
    recordSelection,
    track,
    isInternalQA
  };
})();